export default "__VITE_ASSET__CsUX06E0__"